import type { Translator } from '../i18n/i18n'
import type { MobilityProviderId } from '../types'

interface ProviderCompareProps {
  order: MobilityProviderId[]
  t: Translator
  comparisonEnabled: boolean
  onSelect: (provider: MobilityProviderId) => void
}

export function ProviderCompare({
  order,
  t,
  comparisonEnabled,
  onSelect,
}: ProviderCompareProps) {
  const options: Record<MobilityProviderId, { label: string; note: string }> = {
    kride: {
      label: t('krideCta'),
      note: t('kridePrefillNotice'),
    },
    uber: {
      label: t('uberCta'),
      note: t('uberNotInstalled'),
    },
  }

  return (
    <section className="provider-compare" aria-labelledby="provider-compare-heading">
      <p className="provider-lead" id="provider-compare-heading">
        <strong>{t('fareLead')}</strong><br />{t('providerQuestion')}
      </p>
      <div className="provider-options">
        {order.map((provider) => {
          const option = options[provider]
          return (
            <div className="provider-option" key={provider} data-provider={provider}>
              <button
                className="provider-button"
                type="button"
                onClick={() => onSelect(provider)}
                disabled={!comparisonEnabled}
              >
                <bdi>{option.label}</bdi>
              </button>
              <p className="provider-note">{option.note}</p>
            </div>
          )
        })}
      </div>
      <p className="tap-note">{t('providerTapNote')}</p>
    </section>
  )
}
